// extracted by mini-css-extract-plugin
export default {"talk":"talk_talk__CZ8YG","content":"talk_content__jNrnj"};